module.exports = __webpack_public_path__ + "static/media/skillimg.df3dd19d.jpg";